import type { IconProps } from './IconProps';

export function HeadphonesIcon({ className }: IconProps) {
  return <svg className={className} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <path d="M4 13V10a8 8 0 0 1 16 0v3M20 17v1a3 3 0 0 1-3 3h-3" />
    <rect x="2" y="11" width="4" height="7" rx="2" />
    <rect x="18" y="11" width="4" height="7" rx="2" />
  </svg>;
}
